
export enum ShipmentHistoryDetailCd {
	ADMIN = 'Admin',
	MOVEMENT = 'Movement',
	TRACE = 'Trace'}
